import { render } from "./mat-chipset.vue?vue&type=template&id=44bfe62a&scoped=true&lang=true"
import script from "./mat-chipset.vue?vue&type=script&lang=js"
export * from "./mat-chipset.vue?vue&type=script&lang=js"

import "./mat-chipset.vue?vue&type=style&index=0&id=44bfe62a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bfe62a"]])

export default __exports__